module.exports = `${require.publicPath}203.3a2f5604.png`;